import {
  TagStateContext,
  TagStateDispatchContext,
} from "app/context/tags/context";
import { useContext } from "react";

export function useTagState() {
  const context = useContext(TagStateContext);
  if (context === undefined) {
    throw new Error("useTagState must be used within a TagProvider");
  }
  return context;
}

export function useTagDispatch() {
  const context = useContext(TagStateDispatchContext);
  if (context === undefined) {
    throw new Error("useTagState must be used within a TagProvider");
  }
  return context;
}
